export interface PaginationParamsOptions {
	limit: number
	cursor?: string
	section?: string
	folderId?: string | null
	teamId?: string | null
}

export function buildPaginationParams(options: PaginationParamsOptions): URLSearchParams {
	const params = new URLSearchParams()

	params.set('limit', options.limit.toString())

	if (options.cursor) {
		params.set('cursor', options.cursor)
	}

	if (options.section && options.section !== 'all') {
		params.set('section', options.section)
	}

	if (options.folderId !== null && options.folderId !== undefined && options.folderId !== '') {
		params.set('folderId', options.folderId)
	}

	if (options.teamId !== null && options.teamId !== undefined) {
		params.set('team_id', options.teamId)
	}

	return params
}
